export default __webpack_public_path__ + "static/media/sales.ca12cdab.svg";